import { render, staticRenderFns } from "./CardV2.vue?vue&type=template&id=5d1b70ff"
var script = {}
import style0 from "./CardV2.vue?vue&type=style&index=0&id=5d1b70ff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports